<template>
  <section>
    <!--工具条-->
    <!--<el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addHandler">新增</el-button>
    </el-col>-->
  
    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button>
      </el-input>
    </el-col>
    <el-table :data="tableData" border v-loading="listLoading">
      <el-table-column label="ID" prop="id" align="center">
      </el-table-column>
      <el-table-column label="模版名称" prop="name" align="center">
      </el-table-column>
      <el-table-column label="物流单位" prop="wuliu_company" align="center">
      </el-table-column>
      <el-table-column label="是否通用"  prop="an_jian"
        align="center">
        <template scope="scope">
          <div>{{tongyongStatus[scope.row.is_currency]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="是否按件"
        prop="an_jian"
        align="center">
        <template scope="scope">
          <div>{{anjianStatus[scope.row.an_jian]}}</div>
        </template>
      </el-table-column>
      <el-table-column label="通用价格" prop="currency_price" align="center">
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button :plain="true" size="small" type="info"  @click="editHandler(scope.row)">修改</el-button>
          <el-button :plain="true" size="small" type="danger"  @click="deleteHandler(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="addForm.name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="物流单位" prop="wuliu_company">
          <el-input v-model="addForm.wuliu_company" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否通用" prop="is_currency">
          <el-switch
            v-model="is_currency"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="是否按件计算" prop="an_jian" v-if="is_currency === '1'">
          <el-switch
            v-model="an_jian"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="通用价格" prop="currency_price" v-if="is_currency === '1'">
          <el-input v-model="addForm.currency_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="editForm.name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="物流单位" prop="wuliu_company">
          <el-input v-model="editForm.wuliu_company" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否通用" prop="is_currency">
          <el-switch
            v-model="is_currency"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
         <el-form-item label="是否按件计算" prop="an_jian" v-if="is_currency === '1'">
          <el-switch
            v-model="an_jian"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
            </el-form-item>
        <el-form-item label="通用价格" prop="currency_price" v-if="is_currency === '1'">
          <el-input v-model="editForm.currency_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
   import basicdata from '../../static/config/basicdata.js'
  
  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        anjianStatus: basicdata.anjianStatus,
         tongyongStatus: basicdata.tongyongStatus,
        addForm: {
          name: '',
          wuliu_company: '',
          an_jian:0,
          is_currency: 1,
          currency_price: 0,
          admin_id: 0,
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        an_jian:'1',
        is_currency: '0',
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/kuaidi/moban/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if (data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.addForm);
              para.an_jian= parseInt(this.an_jian);
              para.is_currency = parseInt(this.is_currency);
              para.currency_price = parseInt(para.currency_price);
              //异步请求
              this.$axios.post(config.api_url + '/kuaidi/moban',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      //操作删除
      deleteHandler(id) {
        if (id != 0) {
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/kuaidi/moban/' + id).then(response => {
              if (response.data.state) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row
        this.is_currency = row.is_currency.toString();
        this.an_jian = row.an_jian.toString();
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              para.is_currency = parseInt(this.is_currency);
              para.an_jian = parseInt(this.an_jian);
              para.currency_price = parseInt(para.currency_price);
              //异步请求
              this.$axios.put(config.api_url + '/kuaidi/moban',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      addHandler() {
        this.addFormVisible = true;
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// moban.vue?2b332f74